export * from './countries';
export * from './form-messages';
export * from './labels';
export * from './states';
export * from './enums';
export * from './z-index';

export const TRIP_ADVISOR_RATINGS_KEY = 'trip_advisor';
export const GOOGLE_RATINGS_KEY = 'google_reviews';
export const PAGE_CACHE_REVALIDATION_TTL = 14400; // 14400 seconds == 4 hours
export const GRAY_PIXEL_DATA_URL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcXg8AAdMBKJ79nBQAAAAASUVORK5CYII=';
export const TRUSTPILOT_REVIEWS_URL =
  'https://www.trustpilot.com/review/savvy.com';
